import React from "react";
import "./styles.css";
import Anchor from "../../UI/anchor";

function TeamCard({ image, role, name, link }) {
  return (
    <div className="team-card">
      <img src={image} alt="member of team" />
      <Anchor text={name} color={"#109cf1"} link={link} />
      <p>{role}</p>
    </div>
  );
}

export default TeamCard;
